import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PhotosActions } from '../_store/Photos.slice';
import '../css/Photos.css'
import Table from '../components/common/CustomTable';
import Button from '../components/common/ui/Button';
import ScrollContainer from '../components/common/ScrollContainer';
import Loader from '../components/common/Loader';
import CustomModal from '../components/common/CustomModal ';
import { KioskDashboardActions } from '../_store';
import TranslateFile from '../Loc/TranslateFile';
import CustomPhoto from '../components/common/CustomPhoto';
import useKioskRestrictIntervalValidation from '../hooks/useKioskRestrictIntervalValidation';
import useBrowserType from '../hooks/useBrowserType';
import { getStoredValue, setStoredValue, removeStoredValue } from "../../src/_helpers/storageHelper";

const Photos = () => {

    const LoadPhotoSearchDetails = useSelector(state => state.Photos.LoadPhotoSearchDetails);
    const [LoadPhotoSearchList, setLoadPhotoSearchList] = useState(LoadPhotoSearchDetails);
    const dispatch = useDispatch();
    const loginResponse = useSelector(state => state.kioskLogin.loginResponse);
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const [isshowListPage, setisshowListPage] = React.useState(true);
    const [selectItem, setselectItem] = React.useState();
    const [rotation, setRotation] = useState(0);
    const loginDetails = useSelector(state => state.kioskLogin.loginDetails);
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const [imgsrc, setimgsrc] = useState();
    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const currentLang = TranslateFile();
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
    const [currentPage, setcurrentPage] = React.useState(1);
    const [rowPerPage, setrowPerPage] = React.useState(10);
    const { isPageReload: isPageReloading, isSignalRData } = useSelector((state) => state.auth);
    const browser = useBrowserType();


    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);


    const formatDate = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();

        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // convert 0 → 12

        return `${month}/${day}/${year} ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
    };

    const columns = [
        {
            name: currentLang?.TableHeaders.Subject, width: '330px', selector: (row) => row.PhotoSubject, sortable: true,
            cell: (row) => (
                <div className="d-flex" onClick={() => { handleONCLick(row) }}>
                    {row.PhotoSubject}
                </div>
            ),
            sortFunction: (a, b) => a.PhotoSubject.toLowerCase().localeCompare(b.PhotoSubject.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders.From, selector: (row) => row.PhotoFrom, sortable: true,
            sortFunction: (a, b) => a.PhotoFrom.toLowerCase().localeCompare(b.PhotoFrom.toLowerCase())
        },
        {
            name: currentLang?.TableHeaders?.Date_Time, width: '200px', selector: (row) => row.ApproveOrRejectDate, sortable: true,
            sortFunction: (a, b) => new Date(a.ApproveOrRejectDate) - new Date(b.ApproveOrRejectDate),
        },
        {
            name: currentLang?.TableHeaders?.Status, width: '120px', selector: (row) => row.PhotoReadStatus, sortable: true,
            cell: (row) => (
                <div className="d-flex " title={row.PhotoReadStatus ? 'Read' : 'Unread'} onClick={() => { handleONCLick(row) }}>
                    {PhotoReadStatus(row.PhotoReadStatus)}
                </div>
            ),
        }
    ];

    const PhotoReadStatus = (status) => {
        return <span className={`${status ? 'StatusSent' : 'StatusPatch-danger'}`}>{status ? 'Read' : 'Unread'}</span>;
    };

    useEffect(() => {

        switch (isSignalRData?.type) {
            // case 'Send_Photo':
            //     var Objectdata = {
            //         sortField: "PhotoCommID Desc", subject: '', userLastName: '', userFirstName: '', receiverRead: 2,
            //         messageID: 0, inmatesId: storedloginResponse?.InmateID, pageNo: currentPage, rowCountPerPage: rowPerPage
            //     };
            //     dispatch(PhotosActions.getLoadPhotoSearch(Objectdata)).then(x => {
            //         setLoadPhotoSearchList(x?.payload)
            //         setLoading(false);
            //     });
            //     break;
            case 'Reject_Photo':
                const isPhotothere = LoadPhotoSearchList?.DataList?.find((x) =>
                    x?.PhotoCommID == isSignalRData?.message?.PhotoCommID
                )
                const updatePhotos = LoadPhotoSearchList?.DataList?.filter((x) =>
                    x?.PhotoCommID != isSignalRData?.message?.PhotoCommID
                )
                setLoadPhotoSearchList({ ...LoadPhotoSearchList, DataList: updatePhotos, TotalPhotoCount: isPhotothere ? LoadPhotoSearchList?.TotalPhotoCount - 1 : LoadPhotoSearchList?.TotalPhotoCount });
                break;
        }

    }, [isSignalRData]);

    useEffect(() => {
        setisshowListPage(true);
        PageOnLoad(currentPage, rowPerPage);
    }, [loginResponse, isPageReloading, currentPage, rowPerPage]);

    const PageOnLoad = (currentPage, rowPerPage) => {
        setLoading(true);
        var Objectdata = {
            sortField: "PhotoCommID Desc", subject: '', userLastName: '', userFirstName: '', receiverRead: 2,
            messageID: 0, inmatesId: storedloginResponse?.InmateID, pageNo: currentPage, rowCountPerPage: rowPerPage
        };
        dispatch(PhotosActions.getLoadPhotoSearch(Objectdata)).then(x => {
            setLoadPhotoSearchList(x?.payload)
            setLoading(false);
        });
    }

    // Handle page change
    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    // Handle rows per page change
    const handleonChangeRowsPerPage = (rowsPerPage) => {
        setrowPerPage(rowsPerPage);
    }

    const handlePhotoLoginLog = async (item) => {
        var Objectdata = {
            photoCommID: item?.PhotoCommID, publicUserID: item?.PublicUserID,
            inmateID: storedloginResponse?.InmateID, inmateResidentID: storedloginResponse?.InmatesResdId,
            facilityID: storedloginResponse?.facilityID, kioskCode: storedLoginDetails?.KiosksCode
        };
        dispatch(PhotosActions.LoadPhotoLoginLog(Objectdata));
    }

    const handleONCLick = async (item) => {
        setLoading(true);
        setRotation(0);
        dispatch(PhotosActions.loadPhotoDetails({ PhotoCommID: item?.PhotoCommID })).then(x => {
            const result = x?.payload; setLoading(false);
            if (result?.IsPhotoApprove) {
                setisshowListPage(false); setselectItem(item);
                //   if (result?.IsPhotoBinarySave == 1 || result?.PhotoBinaryData) {
                setimgsrc(result?.IsPhotoBinarySave == 1 ? `data:image/png;base64,${result?.PhotoBinaryData}` : result?.PhotoAttachPath);
                //   }
                // else {
                //     setimgsrc(`${process.env.REACT_APP_API_IMAGE_URL}/UploadFiles${result?.PhotoAttachPath}`)
                // }
            }
            else {
                setShowPopup(true);
            }
        })

        if (item?.PhotoReadStatus == false) {
            var browserType = browser;
            var IpAddress = getStoredValue("cachedIP") || 'Unknown';
            var Objectdata = {
                photoAccess: item?.PhotoCommID, kioskCode: storedLoginDetails?.KiosksCode, browerType: browserType, ipAddress: IpAddress,
                inmatesId: storedloginResponse?.InmateID, PublicUserID: item?.PublicUserID
            };
            dispatch(PhotosActions.loadInsertUpdateUspInmateInboxPhotoRead(Objectdata)).then(x => {
                const podCode = storedLoginDetails?.PodCode;
                const inmateID = storedloginResponse?.InmateID;
                if (inmateID && podCode)
                    dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
            })
        }
        handlePhotoLoginLog(item);
    }

    return (
        <>
            <div className="dashboard-container">
                <div className="dashboard-content">
                    <div className="d-flex justify-content-between mb-1 pt-1">
                        <div className="align-self-start">
                            <div className="icon-container">
                                <h3 className="find-inmate-head">{currentLang?.Photos}</h3>
                            </div>
                        </div>
                        {!isshowListPage && <div className="align-self-end">
                            <Button
                                className='btn-danger'
                                label={currentLang?.Buttons?.Back}
                                type="button"
                                status="back"
                                onClick={() => { setisshowListPage(true); PageOnLoad(currentPage, rowPerPage); }}
                            />
                        </div>}
                    </div>

                    <div className="divider mb-3"></div>

                    <div className="card-default">

                        {isshowListPage ?
                            (LoadPhotoSearchList?.DataList?.length > 0 ?
                                <>
                                    <label className="instructNotes"><i class="fa fa-info-circle no-cursor"></i> {currentLang?.MyContacts?.MyContacts_TableDes}</label>
                                    <Table
                                        isScrollContainer={true}
                                        columns={columns}
                                        data={LoadPhotoSearchList?.DataList.map(
                                            (item) => ({
                                                ...item, ApproveOrRejectDate: item?.ApproveOrRejectDate ? formatDate(item?.ApproveOrRejectDate) : item?.PhotoSendDateTime,
                                                PhotoFrom: item?.LastName ? item?.LastName + " " + item?.FirstName : item?.PhotoFrom
                                            })
                                        )}
                                        pagination={true}
                                        handleONCLick={handleONCLick}
                                        onChangeRowsPerPage={handleonChangeRowsPerPage}
                                        onChangePage={handlePageChange}
                                        totalRowCount={LoadPhotoSearchList?.TotalPhotoCount}
                                        currentPage={currentPage}
                                        paginationPerPage={rowPerPage}
                                        paginationServer={true}
                                    />
                                </> : (!loading && <span className="col-no-data">{currentLang?.No_Data_Found}</span>))
                            :
                            <ScrollContainer>
                                <div className="message-container">
                                    {/* Form Grid */}
                                    <div className="row Photosform-grid">
                                        <div className="col-lg-3 grid-item mb-1">
                                            <p className='mb-0 '>{currentLang?.TableHeaders?.From}</p>
                                            <p className="bold-text text-default-red mb-0" >{selectItem?.PhotoFrom}</p>
                                        </div>
                                        <div className="col-lg-6 grid-item mb-1">
                                            <p className='mb-0'>{currentLang?.TableHeaders?.Subject}</p>
                                            <p className="bold-text text-default-red mb-0 ">{selectItem?.PhotoSubject}</p>
                                        </div>
                                        <div className="col-lg-3 grid-item mb-1">
                                            <p className='mb-0'>{currentLang?.TableHeaders?.Date}</p>
                                            <p className="bold-text text-default-red mb-0">{selectItem?.ApproveOrRejectDate}</p>
                                        </div>

                                    </div>

                                    <CustomPhoto rotation={rotation} setRotation={setRotation}
                                        setLoading={setLoading} imgsrc={imgsrc} />

                                    <p className="textnote">
                                        <i>{currentLang?.Messages?.Textnote}</i>
                                    </p>
                                </div>
                            </ScrollContainer>
                        }

                    </div>
                </div>

                {showPopup && (
                    <CustomModal
                        color={'#c8605e'}
                        content={currentLang?.AlertPopup?.Photo_Rejected_Administrator}
                        onOkClick={() => { setShowPopup(false); setRotation(0); }}
                    />
                )}
            </div>
            {loading && <Loader />}
        </>
    );
};



export default memo(Photos);

